// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_components_login_login_module_ts":"42f54fe3b5d89084","src_app_components_my-account_my-account_module_ts":"42d90b0f2ab1b12a"}[chunkId] + ".js";
};